import React, {Component} from 'react';
import {Button, Form, Header, Icon, Modal,Message} from 'semantic-ui-react';
import AccountExpenseContainer from "../../../containers/account_expense_container";
import Loader from "../../universal/loader";

class AddExpense extends Component {

    constructor(props) {
        super(props);
        this.state = {
            show: true,
            message: undefined,
            isPositive:true,
            disabled:false,
            aec:0,
            tc:0,
            pc:0,
            fc:0,
        }
    }

    handleExpenseAdd = (e) => {
        e.preventDefault();
        this.setState({disabled:true});
        let sum = parseFloat(this.state.aec)+parseFloat(this.state.tc)+parseFloat(this.state.pc)+parseFloat(this.state.fc);
        if(sum > 0){
            const formData = new FormData(e.target);
            this.props.createExpense(formData,this.props.inspectionId,this.onSuccessCallBack);
        }
        else {
            this.setState({disabled:false,showMessage:true,isPositive:false,message:"Expenses total need to be greater than 0"});
        }
    };

    onSuccessCallBack = (response) => {
        if(response.success){
            this.setState({showMessage:true,isPositive:true,message:"Expense Added Successfully",disabled:false});
            this.props.goBack();
        }
        else {
            this.setState({showMessage:true,isPositive:false,message:response.message,disabled:false});
        }
    };

    render() {
        return (
            <div style={{width:'50%',margin:'auto'}} className="pad-top">
                {this.state.disabled && <Loader save={true}/>}
                <Header content="Add Expenses" textAlign="center"/>
                {this.state.showMessage && <Message positive={this.state.isPositive} error={!this.state.isPositive} onDismiss={() =>{this.setState({showMessage:false})}}>
                    <Message.Header>
                        {this.state.message}
                    </Message.Header>
                </Message>}
                <Form onSubmit={this.handleExpenseAdd}>
                    <input type="hidden" name="inspection_id" value={this.props.inspectionId}/>
                    <input type="hidden" name="user_id" value={this.props.userId} />
                    <Form.Group>
                    <Form.Input
                        label="Agreed Extra Charges"
                        name="aec"
                        required
                        defaultValue="0"
                        min='0'
                        type="number"
                        step="0.01"
                        icon='pound'
                        iconPosition='left'
                        onChange={(e) => {this.setState({aec:e.target.value})}}
                    />
                    <Form.Input
                        className="additional-pad"
                        type="file"
                        name="aec_attachment"
                    />
                    </Form.Group>
                    <Form.Group>
                        <Form.Input
                            label="Train Charges"
                            name="train"
                            required
                            defaultValue="0"
                            min='0'
                            step="0.01"
                            type="number"
                            icon='pound'
                            iconPosition='left'
                            onChange={(e) => {this.setState({tc:e.target.value})}}
                        />
                        <Form.Input
                            className="additional-pad"
                            type="file"
                            name="train_attachment"
                        />
                    </Form.Group>
                    <Form.Group>
                        <Form.Input
                            label="Parking Charges"
                            name="parking"
                            required
                            step="0.01"
                            defaultValue="0"
                            min='0'
                            type="number"
                            icon='pound'
                            iconPosition='left'
                            onChange={(e) => {this.setState({pc:e.target.value})}}
                        />
                        <Form.Input
                            className="additional-pad"
                            type="file"
                            name="parking_attachment"
                        />
                    </Form.Group>
                    <Form.Group>
                        <Form.Input
                            label="Fuel Charges"
                            name="fuel"
                            required
                            step="0.01"
                            defaultValue="0"
                            min='0'
                            type="number"
                            icon='pound'
                            iconPosition='left'
                            onChange={(e) => {this.setState({fc:e.target.value})}}
                        />
                        <Form.Input
                            className="additional-pad"
                            type="file"
                            name="fuel_attachment"
                        />
                    </Form.Group>
                    <Form.TextArea
                        label="Expense Notes"
                        name="notes"
                    />
                    <div className="pad-all right-aligned">
                        <Button  content = 'Cancel' onClick={() => {this.props.goBack()}} />
                        <Button disabled={this.state.disabled} type="submit" primary content="Save Expense"/>
                    </div>
                </Form>
            </div>
        )
    }
}

export default AccountExpenseContainer(AddExpense)


// WEBPACK FOOTER //
// ./src/views/accounts/expense/add_expense.js